import React, { useEffect, useRef } from "react";
import mapboxgl from "mapbox-gl";

mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;

const StoresMap = ({ stores, selectedStoreId, onSelectStore }) => {
  const mapContainer = useRef(null);
  const map = useRef(null);
  const markersRef = useRef([]);

  // Initialize map
  useEffect(() => {
    if (!mapContainer.current) return;

    map.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: "mapbox://styles/mapbox/streets-v11",
      center: [-95.7129, 56.1304],
      zoom: 3.5,
    });

    // Disable scroll zoom
    map.current.scrollZoom.disable();

    return () => map.current?.remove();
  }, []);

  // Add markers
  useEffect(() => {
    if (!map.current) return;

    // Remove old markers
    markersRef.current.forEach((m) => m.remove());
    markersRef.current = [];

    const bounds = new mapboxgl.LngLatBounds();

    stores.forEach((store) => {
      if (isNaN(store.lat) || isNaN(store.lng)) return;

      const marker = new mapboxgl.Marker({ color: "blue" })
        .setLngLat([store.lng, store.lat])
        .addTo(map.current);

      marker
        .getElement()
        .addEventListener("click", () => onSelectStore(store.id));

      markersRef.current.push(marker);
      bounds.extend([store.lng, store.lat]);
    });

    if (!bounds.isEmpty()) {
      map.current.fitBounds(bounds, { padding: 50, maxZoom: 6 });
    }
  }, [stores, onSelectStore]);

  // Fly to selected store
  useEffect(() => {
    if (!map.current || selectedStoreId == null) return;
    const store = stores.find((s) => s.id === selectedStoreId);
    if (store && !isNaN(store.lat) && !isNaN(store.lng)) {
      map.current.flyTo({ center: [store.lng, store.lat], zoom: 18 });
    }
  }, [selectedStoreId, stores]);

  return <div ref={mapContainer} style={{ width: "100%", height: "100%" }} />;
};

export default StoresMap;
